// 计费单

import { HttpNotOnShelfReportList, HttpNotOnShelfReportExport } from '@/service/report';
import TableList from "@components/templates/tablelist";
import { mapGetters } from 'vuex';
export default {
    mixins: [TableList],
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {},
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true },
        };
    },
    methods: {
        ajaxRequest: HttpNotOnShelfReportList,
        interceptRequest(params) {
            if(params.page > 1 || params.rows > 10){
                this.formData.page = params.page;
                this.formData.rows = params.rows;
                params = this.formData;
            } else {
                const search = params.search;
                if(params.organizationId){
                    delete params.organizationId;
                }
                if(params.inboundPlanOrderNo){
                    delete params.inboundPlanOrderNo;
                }
                if(params.orgWarehouseCode){
                    delete params.orgWarehouseCode;
                }
                if(params.lineId){
                    delete params.lineId;
                }
                if(params.status){
                    delete params.status;
                }
                if(params.cartonNo){
                    delete params.cartonNo;
                }
                if(params.tmsNo){
                    delete params.tmsNo;
                }
                if(params.reserveInboundDateStart){
                    delete params.reserveInboundDateStart;
                }
                if(params.reserveInboundDateEnd){
                    delete params.reserveInboundDateEnd;
                }
                if(search.organizationId){
                    params.organizationId = search.organizationId;
                }
                if(search.inboundPlanOrderNo){
                    params.inboundPlanOrderNo = search.inboundPlanOrderNo;
                }
                if(search.orgWarehouseId){
                    const orgWarehouseId = search.orgWarehouseId;
                    (this.getBillcusWareList).find(function (item) {
                        if(item.value == orgWarehouseId){
                            params.orgWarehouseCode = item.attach.code;
                        }
                    }) || {};
                }
                if(search.lineId){
                    params.lineId = search.lineId;
                }
                if(search.status){
                    params.status = search.status;
                }
                if(search.cartonNo){
                    params.cartonNo = search.cartonNo;
                }
                if(search.tmsNo){
                    params.tmsNo = search.tmsNo;
                }
                if(search.reserveInboundDate){
                    const reserveInboundDate = search.reserveInboundDate||'';
                    const estArray = reserveInboundDate.split('~');
                    params.reserveInboundDateStart = estArray[0];
                    params.reserveInboundDateEnd = estArray[1];
                }
                delete params.search.inboundPlanOrderNo;
                delete params.search.orgWarehouseId;
                delete params.search.lineId;
                delete params.search.status;
                delete params.search.cartonNo;
                delete params.search.tmsNo;
                delete params.search.reserveInboundDate;
                delete params.search.organizationId;
                this.formData = params;
            }
            return params
        },
        handleOperates(params = "", type, batch) {
            switch (type) {
                case 'export':
                    this.handleWebfs(HttpNotOnShelfReportExport, this.formData, 'download')
                    break;
                case 'queryBlank':
                    window.open(this.$router.resolve({
                        name: "inboundBillclientDetail",
                        params: { type:'query' },
                        query: { id: params },
                    }).href, '_blank');
                    break;

            }
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getBillcusorgList', 'getCusproductList', 'getBillcusWareList']),
        ...mapGetters('common', ['getOnshelfStatue']),
        ToolsData() {
            return [
                {
                    name: "导出",
                    operate: "export",
                    theme: "info",
                },
            ]
        },
        SearchsData() {
            return [
                {
                    label: "入库计划单号",
                    key: 'inboundPlanOrderNo',
                    show: true,
                    tag: 'vInput',
                },
                {
                    label: "客户组织",
                    key: 'organizationId',
                    show: true,
                    tag: 'vSelect',
                    options: this.getBillcusorgList,
                    props: {
                        filterable: true,
                    },
                },
                {
                    label: "仓库",
                    key: 'orgWarehouseId',
                    show: true,
                    tag: 'vSelect',
                    options: this.getBillcusWareList,
                    props: {
                        filterable: true,
                    },
                    style: "width:250px",
                },
                {
                    label: "集装箱号",
                    key: 'cartonNo',
                    more: true,
                    tag: 'vInput',
                },
                {
                    label: "物流单号",
                    key: 'tmsNo',
                    more: true,
                    tag: 'vInput',
                },
                {
                    label: "接收状态",
                    key: 'status',
                    more: true,
                    tag: 'vSelect',
                    options: this.getOnshelfStatue,
                    props: {
                        filterable: true,
                    },
                },
                {
                    label: "项目",
                    key: 'lineId',
                    more: true,
                    tag: 'vSelect',
                    options: this.getCusproductList,
                    props: {
                        filterable: true,
                        // multiple: true,//多选条件
                    },
                    style: "width:250px",
                },
                {
                    label: "预约送仓时间",
                    tag: 'vDatepicker',
                    key: 'reserveInboundDate',
                    more: true,
                    props: {
                        options: this.options,
                        format: 'yyyy-mm-dd 00:00:00 ~ yyyy-mm-dd 00:00:00',
                        confirm: false,
                    },
                    style: "width:250px",
                },

            ]
        },
        columns() {
            return [
                {
                    title: '入库计划单号',
                    render: (h, { row }) => {
                        return <div>
                            <a onClick={this.handleOperates.bind(this, row.inboundPlanOrderId, 'queryBlank')}>{row.inboundPlanOrderNo || '--'}</a>
                        </div>
                    }
                },
                {
                    title: '客户组织',
                    render: (h, { row }) => {
                        let organizationId = row.organizationId
                        const { label } = this.getBillcusorgList.find(function (item) {
                            return item.value == organizationId
                        }) || {};
                        return <div>
                            <div>{label || '--'}</div>
                        </div>
                    }
                },
                {
                    title: '仓库',
                    maxWidth: 200,
                    render: (h, { row }) => {
                        let orgWarehouseCode = row.orgWarehouseCode
                        const { label } = (this.getBillcusWareList).find(function (item) {
                            return item.attach.code == orgWarehouseCode
                        }) || {};
                        return <div>{label}</div>
                    }
                },
                {
                    title: '项目',
                    render: (h, { row }) =>
                        this.findRenderLabel(
                            this.getCusproductList,
                            row.lineId
                        )
                },
                {
                    title: '集装箱号',
                    key: 'cartonNo',
                },
                {
                    title: '物流单号',
                    key: 'tmsNo',
                },
                {
                    title: '预约送仓时间',
                    key: 'reserveInboundDate',
                },
                {
                    title: '接收状态',
                    maxWidth: 80,
                    render: (h, { row }) => {
                        let status = row.status
                        const { label } = this.getOnshelfStatue.find(function (item) {
                            return item.value == status
                        }) || {};
                        if(status == 0){
                            return <div style='color:#4c9cec;'>{label}</div>
                        } 
                        if(status == 1){
                            return <div style='color:#308130;'>{label}</div>
                        } 
                        if(status == 2){
                            return <div style='color:#cc2b34;'>{label}</div>
                        } 
                    }
                },
                {
                    title: '计划数',
                    key: 'planQty',
                },
                {
                    title: '已接收数',
                    key: 'receivedPalletQty',
                },
                {
                    title: '接收差异',
                    key: 'differenceQty',
                },
            ];
        },
    },
};




